var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper p-1"},[(_vm.getIcon)?_c('img',{class:_vm.getIconClass,attrs:{"src":_vm.getIcon}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }